import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { AdminClubsTab } from '../components/admin/AdminClubsTab';
import { AdminUsersTab } from '../components/admin/AdminUsersTab';
import { AdminCatchesTab } from '../components/admin/AdminCatchesTab';
import { AdminSpotsTab } from '../components/admin/AdminSpotsTab';
import { AdminFishTypesTab } from '../components/admin/AdminFishTypesTab';
import { AdminLureTypesTab } from '../components/admin/AdminLureTypesTab';

type Tab = 'clubs' | 'users' | 'catches' | 'spots' | 'species' | 'lures';

export function AdminPage() {
  const { user, status } = useAuth();
  const [tab, setTab] = useState<Tab>('clubs');

  if (status === 'loading') return <div className="p-4">Loading…</div>;
  if (!user?.isSuperAdmin) return <Navigate to="/dashboard" replace />;

  const tabBtn = (t: Tab, label: string) => (
    <button
      type="button"
      onClick={() => setTab(t)}
      className={`px-3 py-2 text-sm font-medium border-b-2 ${
        tab === t
          ? 'border-teal-500 text-teal-700 dark:text-teal-400'
          : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
      }`}
    >
      {label}
    </button>
  );

  return (
    <div>
      <h1 className="mb-4 text-2xl font-semibold">Admin</h1>
      <div className="mb-4 flex border-b border-slate-200 dark:border-slate-700">
        {tabBtn('clubs', 'Clubs')}
        {tabBtn('users', 'Users')}
        {tabBtn('catches', 'Catches')}
        {tabBtn('spots', 'Spots')}
        {tabBtn('species', 'Species')}
        {tabBtn('lures', 'Lures')}
      </div>
      {tab === 'clubs' && <AdminClubsTab />}
      {tab === 'users' && <AdminUsersTab />}
      {tab === 'catches' && <AdminCatchesTab />}
      {tab === 'spots' && <AdminSpotsTab />}
      {tab === 'species' && <AdminFishTypesTab />}
      {tab === 'lures' && <AdminLureTypesTab />}
    </div>
  );
}
